(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["lonvory-footer"] && !Shopify.designMode) return;
  try {
    
  class LonvoryFooter extends HTMLElement {
    connectedCallback() {
      this.desktopMedia = window.matchMedia('(min-width: 750px)');
      this.syncAccordions = ({ matches }) => {
        for (const accordion of this.querySelectorAll('.lonvory-footer__accordion')) {
          if (matches) {
            accordion.open = true;
          } else if (accordion.hasAttribute('data-mobile-collapsed')) {
            accordion.open = false;
          }
        }
      };
      this.syncAccordions(this.desktopMedia);
      this.desktopMedia.addEventListener('change', this.syncAccordions);
    }

    disconnectedCallback() {
      this.desktopMedia?.removeEventListener('change', this.syncAccordions);
    }
  }

  if (!customElements.get('lonvory-footer')) {
    customElements.define('lonvory-footer', LonvoryFooter);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
